import axiosIns from '@/libs/axios'

const ROOT_URL = '/reports'

export default {
  namespaced: true,
  state: {
    summary: null,
    pnlTimeline: [],
    botPerformance: [],
    trades: [],
    tradesMeta: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    positionCycles: [],
    positionCyclesSummary: null,
    positionCyclesMeta: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    symbolPerformance: [],
    targetCompletion: [],
    operationsLog: null,
    performanceSummary: null,
  },
  getters: {
    summary: s => s.summary,
    pnlTimeline: s => s.pnlTimeline,
    botPerformance: s => s.botPerformance,
    trades: s => s.trades,
    tradesMeta: s => s.tradesMeta,
    positionCycles: s => s.positionCycles,
    positionCyclesSummary: s => s.positionCyclesSummary,
    positionCyclesMeta: s => s.positionCyclesMeta,
    symbolPerformance: s => s.symbolPerformance,
    targetCompletion: s => s.targetCompletion,
    operationsLog: s => s.operationsLog,
    performanceSummary: s => s.performanceSummary,
  },
  mutations: {
    SET_SUMMARY(state, data) { state.summary = data },
    SET_PNL_TIMELINE(state, data) { state.pnlTimeline = data },
    SET_BOT_PERFORMANCE(state, data) { state.botPerformance = data },
    SET_TRADES(state, data) { state.trades = data },
    SET_TRADES_META(state, data) { state.tradesMeta = data },
    SET_POSITION_CYCLES(state, data) { state.positionCycles = data || [] },
    SET_POSITION_CYCLES_SUMMARY(state, data) { state.positionCyclesSummary = data || null },
    SET_POSITION_CYCLES_META(state, data) { state.positionCyclesMeta = data },
    SET_SYMBOL_PERFORMANCE(state, data) { state.symbolPerformance = data },
    SET_TARGET_COMPLETION(state, data) { state.targetCompletion = data },
    SET_OPERATIONS_LOG(state, data) { state.operationsLog = data },
    SET_PERFORMANCE_SUMMARY(state, data) { state.performanceSummary = data },
  },
  actions: {
    getSummary({ commit }) {
      return axiosIns.get(`${ROOT_URL}/summary`)
        .then(response => commit('SET_SUMMARY', response.data.data))
        .catch(error => { console.error(error); commit('SET_SUMMARY', null) })
    },
    getPnlTimeline({ commit }, { days = 30 } = {}) {
      return axiosIns.get(`${ROOT_URL}/pnl-timeline`, { params: { days } })
        .then(response => commit('SET_PNL_TIMELINE', response.data.data))
        .catch(error => { console.error(error); commit('SET_PNL_TIMELINE', []) })
    },
    getBotPerformance({ commit }, { limit = 50 } = {}) {
      return axiosIns.get(`${ROOT_URL}/bot-performance`, { params: { limit } })
        .then(response => commit('SET_BOT_PERFORMANCE', response.data.data))
        .catch(error => { console.error(error); commit('SET_BOT_PERFORMANCE', []) })
    },
    getTrades({ commit }, params = {}) {
      return axiosIns.post(`${ROOT_URL}/trades`, params)
        .then(response => {
          commit('SET_TRADES', response.data.data)
          commit('SET_TRADES_META', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
        })
        .catch(error => { console.error(error); commit('SET_TRADES', []) })
    },
    getPositionCycles({ commit }, params = {}) {
      return axiosIns.post(`${ROOT_URL}/position-cycles`, params)
        .then(response => {
          const data = response.data.data || {}
          commit('SET_POSITION_CYCLES', data.rows || [])
          commit('SET_POSITION_CYCLES_SUMMARY', data.summary || null)
          commit('SET_POSITION_CYCLES_META', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_POSITION_CYCLES', [])
          commit('SET_POSITION_CYCLES_SUMMARY', null)
        })
    },
    exportTradesCsv(_ctx, params = {}) {
      // Server-side bulk CSV — pagination yok, tüm filtreli kayıtlar
      return axiosIns.post(`${ROOT_URL}/trades/export-csv`, params, { responseType: 'blob' })
        .then(response => {
          // Backend Content-Disposition başlığından dosya adı çıkar (varsa)
          const cd = response.headers['content-disposition'] || ''
          const match = /filename="?([^"]+)"?/.exec(cd)
          const filename = match ? match[1] : `trades-${new Date().toISOString().slice(0, 10)}.csv`
          const url = URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8' }))
          const a = document.createElement('a')
          a.href = url; a.download = filename
          document.body.appendChild(a); a.click(); document.body.removeChild(a)
          URL.revokeObjectURL(url)
        })
    },
    getSymbolPerformance({ commit }) {
      return axiosIns.get(`${ROOT_URL}/symbol-performance`)
        .then(response => commit('SET_SYMBOL_PERFORMANCE', response.data.data))
        .catch(error => { console.error(error); commit('SET_SYMBOL_PERFORMANCE', []) })
    },
    getTargetCompletion({ commit }) {
      return axiosIns.get(`${ROOT_URL}/target-completion`)
        .then(response => commit('SET_TARGET_COMPLETION', response.data.data))
        .catch(error => { console.error(error); commit('SET_TARGET_COMPLETION', []) })
    },
    getOperationsLog({ commit }) {
      return axiosIns.get(`${ROOT_URL}/operations-log`)
        .then(response => commit('SET_OPERATIONS_LOG', response.data.data))
        .catch(error => { console.error(error); commit('SET_OPERATIONS_LOG', null) })
    },
    getPerformanceSummary({ commit }, { days = 7 } = {}) {
      return axiosIns.get(`${ROOT_URL}/performance-summary`, { params: { days } })
        .then(response => commit('SET_PERFORMANCE_SUMMARY', response.data.data))
        .catch(error => { console.error(error); commit('SET_PERFORMANCE_SUMMARY', null) })
    },
  },
}
